module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showBorders) ? _c('div', {
    staticClass: "mxr-l-borders"
  }, [_c('div', {
    staticClass: "mxr-l-borders--top"
  }, [(_vm.showCorners) ? _c('span', {
    staticClass: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.showCorners) ? _c('span', {
    staticClass: "right"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-l-borders--right",
    class: {
      hasLabel: _vm.nextLabel
    }
  }, [(_vm.nextLabel) ? _c('div', {
    staticClass: "mxr-l-borders__next number",
    on: {
      "click": _vm.getNext
    }
  }, [_vm._v(_vm._s(_vm._f("padToTwo")(_vm.nextLabel)))]) : _vm._e(), _vm._v(" "), (_vm.nextArrow) ? _c('div', {
    staticClass: "mxr-l-borders__next arrow show-for-medium",
    on: {
      "click": _vm.getNextSlider
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-long-arrow-right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-l-borders--bottom"
  }, [(_vm.showCorners) ? _c('span', {
    staticClass: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.showCorners) ? _c('span', {
    staticClass: "right"
  }) : _vm._e(), _vm._v(" "), (_vm.showGender !== undefined) ? _c('div', {
    staticClass: "mxr-l-borders__title"
  }, [_vm._v("\n      12 looks\n      "), _c('span', [_vm._v(_vm._s(_vm.genderType))])]) : _vm._e(), _vm._v(" "), (_vm.showChevronDown) ? _c('button', {
    staticClass: "mxr-look__scroll mxr-l-borders__scroll show-for-medium"
  }, [_c('i', {
    staticClass: "zmdi zmdi-long-arrow-down"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-l-borders--left",
    class: {
      hasLabel: _vm.prevLabel
    }
  }, [(_vm.showText) ? _c('div', {
    staticClass: "mxr-l-borders__vtext"
  }, [_vm._v("#DRESSYOURRUN")]) : _vm._e(), _vm._v(" "), (_vm.prevLabel) ? _c('div', {
    staticClass: "mxr-l-borders__prev number",
    on: {
      "click": _vm.getPrev
    }
  }, [_vm._v(_vm._s(_vm._f("padToTwo")(_vm.prevLabel)))]) : _vm._e(), _vm._v(" "), (_vm.prevArrow) ? _c('div', {
    staticClass: "mxr-l-borders__prev arrow show-for-medium",
    on: {
      "click": _vm.getPrevSlider
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-long-arrow-left"
  })]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18158b45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Borders.vue
// module id = 451
// module chunks = 1